<template>
  <div class="header__search-panel search-panel search-panel_type_float">

    <div class="catalog-panel js-catalog-panel hidden">
    </div>

    <div class="search-panel__btn-mobile js-search-btn-mobile">
      <span class="search-panel__btn-mobile-icon icon icon-lupa"></span>
    </div>

    <form action="" class="search-panel__form" @submit="submit">

      <div class="search-container" v-click-outside="hideTitle">
        <input v-model="stringSearch" @keyup="search" @focus="showTitle" value="" id="inputSearch" type="text"
               class="search-panel__input" placeholder="Поиск товаров" name="q" autocomplete="off">

        <div class="title-search-result" v-show="isShowSearchTitle">
          <div class="search-panel__dropdown-result row">

            <div class="search-panel__block search-panel__goods">
              <a class="search-changed" v-if="found.altQuery" :href="'/search/?q=' + found.altQuery">Исправлена
                раскладка клавиатуры. Возможно вы искали "<span>{{ found.altQuery }}</span>"?</a>
              <ul class="search-panel__list">
                <li class="search-panel__list-item" v-for="item in found.elements" :key="item.id">
                  <a class="items-tips__tip" :href="item.url">
                    <img class="items-tips__image"
                         :src="item.picture"
                         alt="">
                    <div class="items-tips__nameAndPriceWrap">
                      <div class="items-tips__nameWrap">
                        <span class="items-tips__name">{{ item.title }}</span>
                      </div>
                    </div>
                  </a>
                </li>

                <div class="items-tips__showAllWrap">
                  <a :href="'/search/?q=' + stringSearch">
                    Все результаты </a>
                </div>

              </ul>
            </div>

            <div class="search-panel__block">
              <h4 class="search-panel__title"><span>Популярные запросы</span></h4>
              <ul class="search-panel__tipsList">
                <li v-for="(item, index) in found.statistics" :key="index"><a :href="'/search/?q=' + item">{{
                    item
                  }}</a></li>
              </ul>
              <h4 class="search-panel__title"><span>Раздел</span></h4>
              <ul class="search-panel__tipsList">
                <li v-for="item in found.sections" :key="item.id"><a :href="item.url">{{ item.title }}</a></li>
              </ul>
            </div>
          </div>

        </div>
      </div>

      <button type="submit" value="" class="search-panel__button">
        <span class="search-panel__button-icon icon icon-lupa"></span>
      </button>
    </form>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Search",
  data: function () {
    return {
      minQuery: 3,
      timeout: 1000,
      timeoutId: 0,
      lastQuery: '',
      lastQueryTime: new Date(),
      stringSearch: '',
      isShowSearchTitle: false,
      found: {},
      CancelToken:false,
      source:false,
    }
  },
  mounted() {
      const source = document.querySelector('.navigation-left.navigation-left_type_float.navigation-left_view_invisible').cloneNode(true);
      document.querySelector('.catalog-panel').append(source);
  },
  methods: {
    search: function () {
      let value = this.stringSearch;
      let rep = /[;:'"+\(\)\{\}\[\]]/ig;
      if (rep.test(value)) {
        value = value.replaceAll(rep, '');
        this.stringSearch = value;
      }

      if (this.stringSearch.length > this.minQuery && this.lastQuery.replace(/\s/g, '') != this.stringSearch) {
        let newQueryTime = new Date();
        if (newQueryTime.getTime() - this.lastQueryTime.getTime() > this.timeout) {
          this.lastQueryTime = new Date();
          this.query();
        } else {
          clearTimeout(this.timeoutId);
          this.timeoutId = setTimeout(() => {
            this.query();
          }, this.timeout);
        }
      }
    },
    query: function () {
      let vm = this;
      this.lastQuery = vm.stringSearch;

      if(typeof vm.source == "object"){
        vm.source.cancel('Operation canceled by the user.');
      }

      vm.CancelToken = axios.CancelToken;
      vm.source = vm.CancelToken.source();

      axios.post(
          '/api/search',
          {
            'query': vm.stringSearch,
          },
          {
            cancelToken: vm.source.token,
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            },
          }
      )
      .then(function (response) {
        vm.found = response.data.result;
        vm.showTitle();
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    submit: function () {
      let vm = this;
      if(typeof vm.source == "object"){
        vm.source.cancel('Operation canceled by the user.');
      }
      this.$router.push({
        path: '/search/',
        query: {q: this.stringSearch}
      });
    },
    showTitle: function () {
      if (Object.keys(this.found).length != 0)
        this.isShowSearchTitle = true;
    },
    hideTitle() {
      this.isShowSearchTitle = false
    },
  },
}
</script>

<style scoped>
.search-panel {
  border: 1px solid #d5d5d5;
  border-right: 0;
  height: 50px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  flex-direction: row;
  flex-wrap: nowrap;
  display: flex;
}

@media screen and (max-width: 1019px) {
  .search-panel {
    -webkit-border-radius: 0;
    border-radius: 0;
    display: block;
  }
}

.search-panel__btn-mobile {
  display: none;
  width: 50px;
  height: 50px;
  font-size: 18px;
  color: #009adf;
  text-align: center;
  line-height: 57px;
  cursor: pointer
}

@media screen and (max-width: 767px) {
  .search-panel__btn-mobile {
    display: block
  }

  .sticky .search-panel__btn-mobile {
    display: none
  }
}

.search-panel__form {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  justify-content: space-between;
  width: 100%
}

.search-changed {
  color: #5f5f5f;
  margin-left: 12px;
  font-size: 16px;
}

.search-changed span {
  color: red;
}

.search-container {
  width: -webkit-calc(100% - 268px);
  width: calc(100% - 248px);
}

.search-panel__input {
  background: #fff;
  font: 300 17px "Roboto", sans-serif;
  color: #333;
  height: 48px;
  line-height: 48px;
  padding: 0 20px;
  outline: 0;
  border: 0;
  -webkit-border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
  width: 100%;
}

.search-panel__input::-webkit-input-placeholder {
  color: #969696
}

.search-panel__input:-moz-placeholder {
  color: #969696
}

.search-panel__input:-ms-input-placeholder {
  color: #969696
}

@media screen and (max-width: 1019px) {
  .search-container {
    width: 100%;
  }

  .search-panel__input {
    -webkit-border-radius: 0;
    border-radius: 0;
    padding: 0 20px 0 30px
  }
}

.search-panel__button {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  background: #fff;
  width: 50px;
  height: 50px;
  color: #009adf;
  border: 1px solid #d5d5d5;
  outline: 0;
  position: relative;
  top: -1px;
  font-size: 16px;
  line-height: 50px;
  cursor: pointer;
  -webkit-border-radius: 0 4px 4px 0;
  border-radius: 0 4px 4px 0;
  -webkit-transition: all .3s linear;
  -o-transition: all .3s linear;
  transition: all .3s linear;
  display: block;
}

.sticky .search-panel .search-panel__button {
  display: block;
}

.sticky .search-panel .search-container {
  width: calc(100% - 50px);
}

.sticky .search-panel .search-panel__form {
  width: calc(100% - 370px);
}

.sticky .search-panel .title-search-result {
  left: 370px;
  position: absolute;
  top: 55px;
  width: calc(100% - 103px);
}

.search-panel__button-icon {
  line-height: 1
}

.search-panel__button:hover {
  border-color: #009adf;
  background: #009adf;
  color: #fff
}

@media screen and (max-width: 1019px) {
  .search-panel__button{
    border-radius: 0px;
    border-right:0px;
  }
  .sticky .search-panel__button {
    position: inherit;
  }
}

.search-panel__dropdown-result {
  position: absolute;
  background-color: #fff;
  width: -webkit-calc(100% - 267px);
  width: calc(100% - 267px);
  padding: 20px 20px;
  border: 1px solid #d5d5d5;
  left: 0px !important;
  top: -5px !important;
  z-index: 13;
  display: flex;
  font-family: Helvetica Neue, Arial, sans-serif;
}

@media screen and (max-width: 767px) {
  .search-panel__dropdown-result {
    display: none !important
  }
}

.search-panel__list {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 17px
}

.search-panel__list-item {
  line-height: 1;
  margin-bottom: 15px
}

.search-panel__list-item:last-child {
  margin-bottom: 0
}

.sticky .search-panel, .sticky .search-panel__button {
  border-top: 0;
  border-bottom: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
  height: 50px;
  flex-direction: row;
  flex-wrap: nowrap;
  display: flex;
}

.sticky .search-panel__input {
  height: 50px;
  line-height: 50px
}

.sticky .search-panel__button {
  top: 0
}

@media screen and (max-width: 767px) {
  .search-panel_type_float {
    border: 0
  }

  .search-panel_type_float .search-panel__form {
    display: none;
    border-top: 1px solid #d5d5d5;
    border-bottom: 1px solid #d5d5d5;
    background: #fff;
    position: relative;
    left: 0;
    top: 10px;
    width: 100vw;
    height: 50px
  }

  .sticky .search-panel_type_float .search-panel__form {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: reverse;
    -webkit-box-orient: horizontal;
    -webkit-flex-direction: row-reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
    top: 0;
    width: 100%;
    overflow: hidden
  }

  .search-panel_type_float.open .search-panel__form {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    overflow: hidden
  }

  .search-panel_type_float .search-panel__input {
    width: -webkit-calc(100% - 50px);
    width: calc(100% - 50px)
  }
}

.title-search-result {
  position: absolute;
  top: 53px;
  left: -1px;
  width: -webkit-calc(100% + 21px);
  width: calc(100% + 21px);
}

.search-panel__dropdown-result a, .search-panel__dropdown-result a:hover {
  text-decoration: none;
}

.search-panel__block {
  width: 33%;
}

.search-panel__goods {
  width: 66%;
}

.search-panel__tipsList {
  list-style: none;
  font-size: 14px;
  line-height: 21px;
  padding-left: 0;
  padding-bottom: 15px;
}

.search-panel__title {
  font-weight: 700;
  color: #5f5f5f;
  padding-bottom: 5px;
  font-size: 15px;
}

.items-tips__tip, .items-tips__tip:link, .items-tips__tip:visited {
  display: flex;
  align-items: center;
  padding: 10px 11px 4px;
  border-bottom: 0;
  height: 69px;
  box-sizing: border-box;
}

.items-tips__image {
  width: 58px;
  height: 58px;
  margin-right: 15px;
  flex-shrink: 0;
}

.items-tips__showAllWrap {
  padding: 15px 0 0 10px;
}

.catalog-panel.js-catalog-panel {
  width: 370px;
  position: relative;
}
</style>